var _g, _g2, _path, _path2, _g3, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgOrderCart = function SvgOrderCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#order-cart_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.714,
    cy: 29.143,
    r: 2.571,
    fill: "#CADEFF",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.714,
    cy: 29.143,
    r: 2.143,
    stroke: "#71ABFA",
    strokeWidth: 0.857
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#order-cart_svg__b)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21.858,
    cy: 29.143,
    r: 2.571,
    fill: "#CADEFF",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.858,
    cy: 29.143,
    r: 2.143,
    stroke: "#71ABFA",
    strokeWidth: 0.857
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.426 5.143h-16.84c-.42 0-.778.305-.845.72l-1.867 11.572a.857.857 0 0 0 .846.993h17.166c.4 0 .748-.277.836-.668l2.377-10.526a1.714 1.714 0 0 0-1.672-2.091Z",
    fill: "#2E71DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.699 5.571H1.5a1.071 1.071 0 1 0 0 2.143h1.62c.423 0 .784.31.847.73L6.21 23.397c.126.84.846 1.46 1.695 1.46h15.54c.82 0 1.525-.582 1.682-1.387l2.532-13.02a.857.857 0 0 0-.842-1.022H7.196a.857.857 0 0 1-.852-.762l-.09-.807A2.571 2.571 0 0 0 3.7 5.57Z",
    fill: "#CADEFF"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#order-cart_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.643a1.5 1.5 0 0 1 1.5-1.5h2.198A3 3 0 0 1 6.68 7.81l.09.807A.429.429 0 0 0 7.196 9h19.621c.809 0 1.417.737 1.262 1.53l-2.532 13.022a2.143 2.143 0 0 1-2.103 1.733H7.904a2.143 2.143 0 0 1-2.118-1.825L3.543 8.508a.429.429 0 0 0-.424-.365H1.5a1.5 1.5 0 0 1-1.5-1.5ZM1.5 6a.643.643 0 0 0 0 1.285h1.619c.636 0 1.177.466 1.271 1.095l2.243 14.953c.095.63.635 1.095 1.272 1.095h15.54c.614 0 1.144-.436 1.261-1.04l2.532-13.02a.429.429 0 0 0-.42-.511H7.195a1.286 1.286 0 0 1-1.278-1.144l-.09-.807A2.143 2.143 0 0 0 3.698 6H1.5Z",
    fill: "#71ABFA"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m17.974 12 .909.945-2.745 2.853h3.148v1.336H16.5v1.71h2.786v1.337H16.5v2.104h-1.286v-2.104H12.43v-1.336h2.785v-1.71H12.43v-1.337h3.148l-2.746-2.853.91-.945 2.116 2.2 2.117-2.2Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "order-cart_svg__a",
    x: 3,
    y: 21.428,
    width: 15.428,
    height: 15.429,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.571
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_16440_466936"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_16440_466936",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "order-cart_svg__b",
    x: 14.143,
    y: 21.428,
    width: 15.428,
    height: 15.429,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.571
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_16440_466936"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_16440_466936",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "order-cart_svg__c",
    x: -3.429,
    y: 1.714,
    width: 34.961,
    height: 27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.714
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_16440_466936"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_16440_466936",
    result: "shape"
  })))));
};

export default SvgOrderCart;